//新闻
const Education = () => import("../views/news/news_education.vue")
//通知公告
const NewsWork = () => import("../views/news/news_work.vue")
//通知公告详情
const NewsWorkDetail = () => import("../views/news/news_work_detail.vue")
//师资培训
const Training = () => import("../views/news/training.vue")
//师资培训详情
const TrainingDetail = () => import("../views/news/training_detail.vue")

// 考试服务详情
const ServiceDetail = () => import("../views/news/service_detail.vue")

const AboutUs = () => import("../views/news/aboutus.vue")

const NewsDetail = () => import("../views/news/news_detail.vue")
const Detail = () => import("../views/news/detail.vue")
// 考试大纲
const Learning = () => import("../views/news/learning.vue")
// 考试大纲详情
const LearningDetail = () => import("../views/news/learning_detail.vue")
// 历年试卷
const Testing = () => import("../views/news/testing.vue")
// 历年试卷详情
const TestingDetail = () => import("../views/news/testing_detail.vue")
const Teaching = () => import("../views/news/teaching.vue")
const AddedService = () => import("../views/news/added-service.vue")
const ImproveService = () => import("../views/news/improve-service.vue")
const TeamList = () => import("../views/news/teamlist.vue")
const teachingdetail = () => import("../views/news/teaching-detail.vue")
const Exhibition = () => import("../views/news/exhibition.vue")
const Groupdetial = () => import("../views/news/groupdetial.vue")
//考试指导
const ExamGuidance = () => import("../views/news/examGuidance.vue")
const ExamGuidanceVideo = () => import("../views/news/examGuidanceVideo.vue")
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default [ 
  
  {
    path: '/groupdetail',
    name: 'groupdetail',
    component: Groupdetial,
    meta: {
      title: {
        content: "组考详情",
      },
      id:2
      // keepAlive: true
    }
  }, {
    path: '/detail/:id',
    name: 'detail',
    component: Detail,
    meta: {
      title: {
        content: "文章详情",
      },
      id:0
      // keepAlive: true
    }
  },  {
    path: '/list/exhibition',
    name: 'exhibition',
    component: Exhibition,
    meta: {
      title: {
        content: "文章详情",
      },
      id:4
      // keepAlive: true
    }
  },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: AboutUs,
      meta: {
        title: {
          content: "关于我们",
        

        },
        id:5
        // keepAlive: true
      }
    },
      {
        path: '/list/information',
        name: 'education',
        component: Education,
        meta: {
          title: {
            content: "教育资讯",
          },
          // keepAlive: true
          id:2

        }
      },
      {
        path: '/list/information/detail/:id',
        name: 'educationDetail',
        component: NewsDetail,
        meta: {
          title: {
            content: "教育资讯详情",
          },
          id:2
          // keepAlive: true
        }
      },
      {
        path: '/list/service/detail/:id',
        name: 'serviceDetail',
        component: ServiceDetail,
        meta: {
          title: {
            content: "教育资讯详情",
          },
          id:0

          // keepAlive: true
        }
      },

     
      {
        path: '/list/course',
        name: 'wrok',
        component: NewsWork,
        meta: {
          title: {
            content: "工作动态",
          },
          id:1

          // keepAlive: true
        }
      },
      {
        path: '/list/course/detail/:id',
        name: 'wrokDetail',
        component: NewsWorkDetail,
        meta: {
          title: {
            content: "工作动态详情",
          },
          id:1

          // keepAlive: true
        }
      },
      {
        path: '/list/training',
        name: 'training',
        component: Training,
        meta: {
          title: {
            content: "工作动态",
          },
          id:0
          // keepAlive: true
        }
      },
      {
        path: '/list/training/detail/:id',
        name: 'trainingDetail',
        component: TrainingDetail,
        meta: {
          title: {
            content: "工作动态详情",
          },
          id:0
          // keepAlive: true
        }
      },
     

      {
        path: '/list/testing/detail/:id',
        name: 'testingDetail',
        component: TestingDetail,
        meta: {
          title: {
            content: "学术动态详情",
          },
          id:0
          // keepAlive: true
        }
      },{
        path: '/list/testing',
        name: 'testing',
        component: Testing,
        meta: {
          title: {
            content: "",
          },
          id:0
          // keepAlive: true
        }
      },
      {
        path: '/list/learning/detail/:id',
        name: 'learningDetail',
        component: LearningDetail,
        meta: {
          title: {
            content: "学术动态详情",
          },
          id:0
          // keepAlive: true
        }
      },{
        path: '/list/learning',
        name: 'learning',
        component: Learning,
        meta: {
          title: {
            content: "",
          },
          id:0
          // keepAlive: true
        }
      },{
        path: '/list/teaching',
        name: 'teaching',
        component: Teaching,
        meta: {
          title: {
            content: "",
          },
          id:0
          // keepAlive: true
        }
      },{
        path: '/list/teaching/detail/:id',
        name: 'teachingdetail',
        component: teachingdetail,
        meta: {
          title: {
            content: "",
          },
          id:0
          // keepAlive: true
        }
      },{
        path: '/list/added',
        name: 'added',
        component: AddedService,
        meta: {
          title: {
            content: "",
          },
          id:3
          // keepAlive: true
        }
      },{
        path: '/list/improve',
        name: 'improve',
        component: ImproveService,
        meta: {
          title: {
            content: "",
          },
          id:3

          // keepAlive: true
        }
      },{
        path: '/list/teamlist',
        name: 'improve',
        component: TeamList,
        meta: {
          title: {
            content: "",
          },
          id:0

          // keepAlive: true
        }
      },
      {
        path: '/list/examGuidance',
        name: 'examGuidance',
        component: ExamGuidance,
        meta: {
          title: {
            content: "考试指导",
          },
          id:1

          // keepAlive: true
        }
      },
      {
        path: '/list/examGuidanceVideo',
        name: 'examGuidanceVideo',
        component: ExamGuidanceVideo,
        meta: {
          title: {
            content: "视频指导",
          },
          id:1

          // keepAlive: true
        }
      },
    ]